import { type ReactNode } from 'react';
import { Dimension } from '@hungryroot/ui-kit';

import styles from './Header.module.css';

interface HeaderProps {
  testid?: string;
  primaryTopIconButton?: ReactNode;
  secondaryTopIconButton?: ReactNode;
  primaryTopRightIconButton?: ReactNode;
}

export function Header(props: HeaderProps) {
  const {
    primaryTopIconButton,
    secondaryTopIconButton,
    primaryTopRightIconButton,
  } = props;
  return (
    <Dimension level="two" className={styles.header}>
      {primaryTopIconButton && <div>{primaryTopIconButton}</div>}
      {secondaryTopIconButton && (
        <div className={styles['secondary-top-icon-button']}>
          {secondaryTopIconButton}
        </div>
      )}
      {primaryTopRightIconButton && (
        <div className={styles['primary-top-right-icon-button']}>
          {primaryTopRightIconButton}
        </div>
      )}
    </Dimension>
  );
}
